import ClampExpandable from './ClampExpandable/ClampExpandable';
import ClampExpandableList from './ClampExpandable/ClampExpandableList';

export default function clampExpanders(expanders) {
  expanders.forEach((el) => {
    if (el.classList.contains('clamp-expandable--list')) {
      el.expandable = new ClampExpandableList(el);
    } else {
      el.expandable = new ClampExpandable(el);
    }
  });
}
